import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import "../CSS/ProjectDetails.css";
import projectsData from "../data/projectsData";
import "react-image-lightbox/style.css"; // Import CSS for the lightbox
import Lightbox from "react-image-lightbox"; // Import the Lightbox component
import tech from "./assets/cpu.png";

const ProjectDetails = () => {
  const { id } = useParams();
  const project = projectsData.find((proj) => proj.id === id);
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [activeTab, setActiveTab] = useState("Frontend"); // State for active tab
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal

  if (!project) {
    return (
      <div className="project-details">
        <h1>Project Not Found</h1>
        <p>The project you are looking for does not exist.</p>
        <Link to="/projects" className="back-link">
          Back to Projects
        </Link>
      </div>
    );
  }

  const technologyCategories = Object.keys(project.technologies);

  return (
    <>
      <div className={`project-details ${isModalOpen ? "blur-background" : ""}`}>
        <Link to="/projects" className="back-link">
          ← Back to Projects
        </Link>
        <h1>{project.name}</h1>
        <div className="images">
          {project.images.map((img, idx) => (
            <img
              src={img}
              alt={`${project.name} screenshot ${idx + 1}`}
              key={idx}
              loading="lazy"
              onClick={() => {
                setPhotoIndex(idx);
                setIsOpen(true);
              }}
              className="project-image"
            />
          ))}
        </div>
        <p>{project.description}</p>

        {/* View Technologies Button */}
        <button
          className="view-technologies-btn"
          onClick={() => setIsModalOpen(true)}
        >
          <img src={tech} alt="View Techologies" />View Technologies
        </button>

        <div className="links">
          <a
            href={project.liveLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn"
          >
            Live Site
          </a>
          <a
            href={project.githubLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn"
          >
            GitHub Repo
          </a>
        </div>

        {/* Lightbox Code (If Using react-image-lightbox) */}
        {isOpen && (
          /* Ensure react-image-lightbox is installed and imported correctly */
          /* Uncomment the following lines if using react-image-lightbox */
          
          <Lightbox
            mainSrc={project.images[photoIndex]}
            nextSrc={project.images[(photoIndex + 1) % project.images.length]}
            prevSrc={project.images[(photoIndex + project.images.length - 1) % project.images.length]}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + project.images.length - 1) % project.images.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % project.images.length)
            }
          />
        
        )}
      </div>

      {/* Technologies Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal-btn" onClick={() => setIsModalOpen(false)}>
              &times;
            </button>
            <h3>Technologies Used</h3>
            {technologyCategories.length > 0 ? (
              <>
                <div className="tabs">
                  {technologyCategories.map((category) => (
                    <button
                      key={category}
                      className={`tab-button ${activeTab === category ? "active" : ""}`}
                      onClick={() => setActiveTab(category)}
                    >
                      {category}
                    </button>
                  ))}
                </div>
                <div className="tab-content">
                  <ul>
                    {project.technologies[activeTab]?.map((tech, idx) => (
                      <li key={idx}>{tech}</li>
                    ))}
                  </ul>
                </div>
              </>
            ) : (
              <p>No technologies listed for this project.</p>
            )}
          </div>
        </div>
      )}

    </>
  );
};

export default ProjectDetails;